import React from "react";
import { Row, Col, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { useTenant } from "../../hooks/useTenant";
import withRouter from "components/Common/withRouter";

// Assets
import new1Bg from "../../assets/images/new1Bg.png";
import neoLogo from "../../assets/images/Neo_Logo_A.svg";

const Home = () => {
  const { user } = useTenant();

  const userName = user?.displayName?.split(" ")[0]?.toUpperCase()
    || user?.fullName?.split(" ")[0]?.toUpperCase()
    || "USUÁRIO";

  return (
    <React.Fragment>
        <Row>
          {/* Lado Esquerdo */}
            <Col lg="7" className="pe-lg-5 d-flex flex-column">
              <div className="mb-4">
                <h3 className="fw-bold mb-1 text-dark" style={{ letterSpacing: '-0.5px' }}>
                  Que bom ter você aqui, {userName}
                </h3>
                <p className="text-muted mb-4 font-size-15">
                  Nesta tela, estão os principais atalhos, as novidades e outros conteúdos.
                </p>

                {/* Atalhos */}
                <Row className="g-4">
                  <Col sm="6">
                    <Link to="/dashboard" className="text-decoration-none">
                      <div className="d-flex flex-column mt-2" style={{ transition: 'all 0.2s', cursor: 'pointer' }} onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; }} onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}>
                        <div className="avatar-md mb-3 rounded-circle bg-soft-primary d-flex align-items-center justify-content-center">
                          <i className="mdi mdi-view-dashboard-outline font-size-24 text-primary"></i>
                        </div>
                        <span className="fw-bold text-dark font-size-16" style={{ letterSpacing: '0.5px' }}>Meu Dashboard</span>
                        <p className="text-muted font-size-13 mt-1 fw-light">Visão geral e gráficos</p>
                      </div>
                    </Link>
                  </Col>

                  <Col sm="6">
                    <Link to="/members" className="text-decoration-none">
                      <div className="d-flex flex-column mt-2" style={{ transition: 'all 0.2s', cursor: 'pointer' }} onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; }} onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}>
                        <div className="avatar-md mb-3 rounded-circle bg-soft-primary d-flex align-items-center justify-content-center">
                          <i className="mdi mdi-account-plus-outline font-size-24 text-primary"></i>
                        </div>
                        <span className="fw-bold text-dark font-size-16" style={{ letterSpacing: '0.5px' }}>Novo Cadastro</span>
                        <p className="text-muted font-size-13 mt-1 fw-light">Adicionar membros</p>
                      </div>
                    </Link>
                  </Col>
                </Row>
              </div>

              {/* Novidades */}
              <div className="flex-grow-1 d-flex flex-column pt-2">
                <h5 className="font-size-15 mb-3 text-muted d-flex align-items-center fw-medium">
                  <i className="mdi mdi-bullhorn-outline me-2 font-size-18"></i>
                  Novidades
                </h5>

                <div className="flex-grow-1 d-flex flex-column mt-4">
                  <div className="mb-4">
                    <h2 className="fw-bold text-dark mb-3" style={{ letterSpacing: '-1px', fontSize: '2.4rem' }}>
                      Revolucione a gestão de treinos
                    </h2>
                    <p className="text-muted font-size-16 mb-0" style={{ maxWidth: '85%', lineHeight: '1.6' }}>
                      Prepare-se para entregar resultados de elite aos seus alunos. A metodologia da academia ganhará uma estrutura completa, conectando o planejamento físico com a execução interativa na beira da piscina.
                    </p>
                  </div>

                  <Row className="mt-4 g-5">
                    <Col sm="6">
                      <div className="d-flex flex-column h-100 pe-3">
                        <div className="mb-3">
                          <i className="mdi mdi-playlist-check text-primary" style={{ fontSize: '42px' }}></i>
                        </div>
                        <h4 className="text-dark fw-bold mb-3" style={{ letterSpacing: '-0.5px', lineHeight: '1.2' }}>
                          Planejamento<br />Metodológico
                        </h4>
                        <p className="font-size-15 mb-0 text-muted fw-light" style={{ lineHeight: '1.6' }}>
                          Configure fichas evolutivas, divida tópicos por nível e avalie a performance técnica do baby class ao master.
                        </p>
                      </div>
                    </Col>

                    <Col sm="6">
                      <div className="d-flex flex-column h-100 pe-3">
                        <div className="mb-3">
                          <i className="mdi mdi-monitor text-primary" style={{ fontSize: '42px' }}></i>
                        </div>
                        <h4 className="text-dark fw-bold mb-3" style={{ letterSpacing: '-0.5px', lineHeight: '1.2' }}>
                          Módulo TV<br />e Cronogramas
                        </h4>
                        <p className="font-size-15 mb-0 text-muted fw-light" style={{ lineHeight: '1.6' }}>
                          Feedback visual em tempo real! Telas nas raias para os alunos acompanharem a série que será trabalhada na aula.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            {/* Lado Direito (Banner Dinâmico com a logo, capa de fundo defocada e cards flutuantes) */}
            <Col lg="5" className="d-flex align-items-stretch mt-4 mt-lg-0">
              <Card className="w-100 border-0 rounded-0 overflow-hidden shadow-lg p-0 position-relative" style={{ minHeight: '820px' }}>
                <div
                  style={{
                    backgroundImage: `url(${new1Bg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100%',
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0
                  }}
                />
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(135deg, rgba(20, 20, 30, 0.85) 0%, rgba(50, 50, 60, 0.75) 100%)',
                  backdropFilter: 'blur(10px)',
                  zIndex: 1
                }} />

                <div className="position-relative d-flex flex-column h-100 p-5 justify-content-between text-white" style={{ zIndex: 2 }}>
                  <div className="d-flex justify-content-end w-100">
                    <img src={neoLogo} alt="NeoApp" style={{ height: '35px', filter: 'brightness(0) invert(1)' }} />
                  </div>


                  {/* BOTTOM TEXT */}
                  <div className="mt-auto position-relative pt-5" style={{ zIndex: 10 }}>
                    <h1 className="fw-bold mb-3 text-white" style={{ letterSpacing: '-1.5px', fontSize: '3.4rem', lineHeight: '1.1' }}>
                      O futuro<br />da sua metodologia.
                    </h1>
                    <p className="font-size-18 mb-4 opacity-75 fw-light" style={{ lineHeight: '1.6' }}>
                      Desbloqueie o novo <strong className="text-white">Módulo TV</strong> e crie <strong className="text-white">Planejamentos</strong> incríveis para guiar seus alunos em cada aula do nível.
                    </p>
                    <div className="mt-4">
                      <button type="button" className="btn btn-lg btn-success rounded-pill fw-bold shadow-sm px-4 d-inline-flex align-items-center" style={{ letterSpacing: '0.5px' }}>
                        <i className="mdi mdi-whatsapp font-size-22 me-2"></i> Fale Conosco
                      </button>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>

          </Row>
    </React.Fragment>
  );
};

export default withRouter(Home);
